<template>
  <div class="sf-page">
    <top-header narrow
                v-bind:title="$t('attendance')" />
    <v-progress-linear color="accent"
                       indeterminate
                       v-bind:active="loading" />
    <div class="sf-container sf-container--narrow">
      <attendance-card v-bind:customers="customers"
                       v-on:confirm="confirmParticipant" />
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';

  import AttendanceCard from '@/components/administration/AttendanceCard'
  import TopHeader from '@/components/common/TopHeader'

  export default {
    components: {
      AttendanceCard,
      TopHeader
    },
    computed: {
      ...mapGetters({
        customers: 'customers'
      })
    },
    async created() {
      this.loading = true
      await this.loadCustomers()
      this.loading = false
    },
    data: () => ({
      loading: false
    }),
    methods: {
      // slot 0 = Kunde selbst, 1–10 = Gast; jede Person wird einzeln bestätigt
      async confirmParticipant({ customer, slot }) {
        this.loading = true

        await this.setAttendingParticipant({ customer, slot })

        this.loading = false
      },
      ...mapActions({
        loadCustomers: 'loadCustomers',
        setAttendingParticipant: 'setAttendingParticipant'
      })
    },
    name: 'Attendance'
  }
</script>

<i18n>
{
  "de": {
    "attendance": "Einlass"
  },
  "en": {
    "attendance": "Attendance"
  }
}
</i18n>